import React from 'react';
import './Topbar.css';

export default function Topbar() {
  return (
    <div className="topbar py-3 px-4 bg-white border-bottom">
      <h5>👋 Welcome to your dashboard</h5>
    </div>
  );
}
